<script setup lang="ts">
import type { BlockProductReviewFragment, ProductReviewDefaultFragment } from '#graphql-operations'

interface BlockProductReviewProps {
  data: BlockProductReviewFragment
}

const props = defineProps<BlockProductReviewProps>()
const reviews = computed(() => props.data.productReview as ProductReviewDefaultFragment[])
const colorScheme = useColorScheme(() => props.data.colorScheme, 'wine-on-linen')
</script>

<template>
  <Section padded class="blockProductReview" :class="colorScheme">
    <div class="container space-y-5 lg:space-y-7.5">
      <div class="layout-grid">
        <Text v-if="data.heading" :html="data.heading" class="text-6.25 leading-7.25 font-normal font-serif col-span-6 xl:text-7.5 xl:leading-8.5 lg:col-start-4" />
      </div>
      <div class="productList gap-1.5 lay-v lg:gap-2.5">
        <CardProductReview v-for="review in reviews" :key="review!.id" :data="review!" />
      </div>
    </div>
  </Section>
</template>

<style scoped>
.productList {
  margin-inline: auto;

  @screen lg {
    --columns: 12;
    --span: 7;
    --gap: calc(var(--spacing) * 2.5);

    max-width: calc(
      (var(--span) / var(--columns)) * 100% - ((var(--columns) - var(--span)) / var(--columns)) * var(--gap)
    );
  }
}
</style>
